export { ProgressHttpModule } from "./lib/progress-http.module";
export { ProgressHttp } from "./lib/progress-http.service";
export { AngularHttpFactory } from "./lib/AngularHttpFactory";
export { HTTP_FACTORY } from "./lib/http-factory.token";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/index.js
// module id = 1480
// module chunks = 3